var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockquote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 33,
    viewBox: "0 0 43 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.898 0.187996L12.448 22.548L10.126 13.26C12.9927 13.26 15.3433 14.0913 17.178 15.754C19.0127 17.4167 19.93 19.71 19.93 22.634C19.93 25.558 18.984 27.9087 17.092 29.686C15.2573 31.406 12.9353 32.266 10.126 32.266C7.31667 32.266 4.966 31.406 3.074 29.686C1.23933 27.9087 0.322 25.558 0.322 22.634C0.322 21.8313 0.379333 21.0287 0.494 20.226C0.666 19.4233 0.952667 18.4487 1.354 17.302C1.75533 16.1553 2.35733 14.6647 3.16 12.83L8.664 0.187996H18.898ZM41.43 0.187996L34.98 22.548L32.658 13.26C35.5247 13.26 37.8753 14.0913 39.71 15.754C41.5447 17.4167 42.462 19.71 42.462 22.634C42.462 25.558 41.516 27.9087 39.624 29.686C37.7893 31.406 35.4673 32.266 32.658 32.266C29.8487 32.266 27.498 31.406 25.606 29.686C23.7713 27.9087 22.854 25.558 22.854 22.634C22.854 21.8313 22.9113 21.0287 23.026 20.226C23.198 19.4233 23.4847 18.4487 23.886 17.302C24.2873 16.1553 24.8893 14.6647 25.692 12.83L31.196 0.187996H41.43Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockquote);
export default __webpack_public_path__ + "static/media/blockquote.eaaebe4ce3fefe3de9733807e25663ca.svg";
export { ForwardRef as ReactComponent };